import * as React from 'react';
import { loadHiddenColumns, saveHiddenColumns } from 'Src/helpers/columnVisibility/columnVisibility';
import BPromise from 'bluebird';
import Lazy from 'lazy.js';
import * as propz from 'propz';
import { AppUser } from 'Src/views/App/App';
import { parse, stringify } from 'query-string';
import { getOrder, getSearchFilter, getSearchOrder, getServerFieldSectionWhere } from 'Src/helpers/table/table';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE, LIMIT } from 'Src/consts/table';
import { Loader } from 'Src/components/Loader/Loader';
import { SelectAllCheckbox } from 'Src/components/SelectAllCheckbox/SelectAllCheckbox';
import {
  ColumnDefinition,
  getFilters2,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import { History, Location } from 'history';
import { getBirthday, getEmailOrMisEmail, getPhoneOrMisPhone, getUserStatus } from 'Src/helpers/accessor/accessor';
import { SchoolUser } from 'Src/models/schoolUser';
import { getAllGovernors, searchGovernors } from 'Src/helpers/service/admin/governors';
import { getUserTags } from 'Src/helpers/accessor/accessor';
import { getSelectOptionForTag } from 'Src/helpers/table/select';
import { PeopleColumnsMenu } from '../PeopleColumnsMenu';
import { countActivePeopleFilters, PeopleFilterChips } from '../PeopleFilterChips';
import '../Students/Students.scss';
import './Governors.css';
import { getAllUserTags } from 'Src/helpers/service/admin/userTags';
import { Tag } from 'Src/models/tag';
import { UserTagAssignModal } from 'Src/components/UserTagAssignModal/UserTagAssignModal';
import { UserTagDeleteModal } from 'Src/components/UserTagDeleteModal/UserTagDeleteModal';
import { updateUserTagsInBulk } from 'Src/helpers/service/admin/users';
import { getUserTagColor } from 'Src/helpers/tags/tagColors';
import { PeopleFilterChipSelect } from '../PeopleFilterChipSelect';
import { Pagination2 } from 'Src/components/Pagination/Pagination2';
import { PeopleListPageHeader } from '../PeopleListPageHeader';
import { ROLE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/user';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faTags, faTrashAlt, faUserShield } from '@fortawesome/free-solid-svg-icons';
import '../AllUsers/Users.css';
import { ListEmptyState } from 'Src/components/ListEmptyState/ListEmptyState';

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Name',
    field: 'firstName',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['firstName']
  },
  {
    text: 'Surname',
    field: 'lastName',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['lastName']
  },
  {
    text: 'Email',
    field: 'email',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['email']
  },
  {
    text: 'Birthday',
    field: 'birthday',
    isSort: true,
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: getBirthday
  },
  {
    text: 'Tag',
    field: 'tag',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getUserTags
  }
];

const NAME_SEARCH_COLUMN: ColumnDefinition = {
  text: 'Name',
  field: 'nameSearch',
  isSort: false,
  type: FILTER_TYPE.TEXT,
  accessor: ['firstName']
};

const PHONE_FILTER_COLUMN: ColumnDefinition = {
  text: 'Phone',
  field: 'phone',
  isSort: false,
  type: FILTER_TYPE.TEXT,
  accessor: ['phone']
};

const FILTER_COLUMNS: ColumnDefinition[] = [...COLUMNS, NAME_SEARCH_COLUMN, PHONE_FILTER_COLUMN];

interface State {
  items: SchoolUser[];
  currentPage: number;
  selectedItems: SchoolUser[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  isSelectAllChecked: boolean;
  excludedSelectionIds: string[];
  total: number;
  basePath: string;
  isUserTagModalOpen: boolean;
  isUserTagDeleteModalOpen: boolean;
  tags: Tag[];
  selectedUserTagId: string;
  hiddenColumns: string[];
  previewUser: SchoolUser | null;
  currentTabIndex: number;
}

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

export class Governors extends React.Component<Props, State> {
  private itemsRequestId = 0;

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isLoading: false,
      isSelectAllChecked: false,
      excludedSelectionIds: [],
      total: 0,
      basePath: '',
      isUserTagModalOpen: false,
      isUserTagDeleteModalOpen: false,
      tags: [],
      selectedUserTagId: '',
      hiddenColumns: loadHiddenColumns(props.user, 'people.governors'),
      previewUser: null,
      currentTabIndex: 0
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    this.setAdditionalItems()
      .catch(error => console.error('Unable to load governor list filters', error))
      .then(() => this.setItems());
    document.addEventListener('mousedown', this.onFilterOutsideClick);
    document.addEventListener('keydown', this.onFilterKeyDown);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true
      });
      this.setItems();
    }
  }

  componentWillUnmount() {
    this.itemsRequestId += 1;
    document.removeEventListener('mousedown', this.onFilterOutsideClick);
    document.removeEventListener('keydown', this.onFilterKeyDown);
  }

  onFilterOutsideClick = (event: MouseEvent): void => {
    const target = event.target as HTMLElement;
    if (!target.closest('.people-filter') && !target.closest('.people-filterBtn')) {
      this.setState({ isShowFilter: false });
      if (this.state.isShowFilter) this.setItems();
    }
  };
  onFilterKeyDown = (event: KeyboardEvent): void => {
    if (event.key === 'Escape') {
      if (this.state.previewUser) {
        this.closeUserPreview();
      }
      this.setState({ isShowFilter: false });
      if (this.state.isShowFilter) this.setItems();
    }
  };

  onUserPreviewClick = (user: SchoolUser): void => {
    this.setState({ previewUser: user, currentTabIndex: 0 });
  };

  closeUserPreview = (): void => {
    this.setState({ previewUser: null, currentTabIndex: 0 });
  };

  usePreviewUserForAction = (callback: () => void): void => {
    const { previewUser } = this.state;

    if (!previewUser) return;

    this.setState(
      {
        selectedItems: [previewUser],
        isSelectAllChecked: false,
        excludedSelectionIds: []
      },
      callback
    );
  };

  setAdditionalItems() {
    const { user } = this.props;

    return getAllUserTags(user)
      .then(tags => {
        this.setState({ tags });

        return true;
      })
      .catch(error => {
        console.error(error);
        return true;
      });
  }

  setItems() {
    const { history, user } = this.props;

    const search = parse(history.location.search);
    const parsedPage = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;
    const page = Number.isInteger(parsedPage) && parsedPage > 0 ? parsedPage : FIRST_PAGE;

    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters2(FILTER_COLUMNS, search);

    const isShowFilter = false;
    const isDataFiltered = isFilterExist2(filters);

    const where = getServerFieldSectionWhere(filters);

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order);

    const requestId = ++this.itemsRequestId;
    this.setState({ isLoading: true });

    return searchGovernors(user, serverQueryFilter)
      .then(({ items, total }) => {
        if (requestId !== this.itemsRequestId) return false;
        const lastPage = Math.max(FIRST_PAGE, Math.ceil(total / LIMIT));
        if (page > lastPage) {
          const nextSearch = { ...search };
          if (lastPage === FIRST_PAGE) delete nextSearch.page;
          else nextSearch.page = String(lastPage);
          history.replace({ pathname: history.location.pathname, search: stringify(nextSearch) });
          return false;
        }
        this.setState({
          currentPage: page,
          sortDirection: sortDirection,
          sortColumnsName: sortColumnsName,
          isShowFilter: false,
          isDataFiltered: isDataFiltered,
          filters: filters,
          items: items,
          previewUser: this.state.previewUser
            ? items.find(item => item.id === this.state.previewUser.id) || null
            : null,
          total,
          basePath: history.location.pathname,
          isLoading: false
        });

        return true;
      })
      .catch(error => {
        if (requestId === this.itemsRequestId) this.setState({ isLoading: false });
        console.error('Unable to load governors', error);
        return false;
      });
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search: string[] = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onItemClick = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedItem = items[index];

    if (this.state.isSelectAllChecked) {
      const excludedSelectionIds = [...this.state.excludedSelectionIds];
      const excludedIndex = excludedSelectionIds.indexOf(selectedItem.id);
      if (excludedIndex === -1) excludedSelectionIds.push(selectedItem.id);
      else excludedSelectionIds.splice(excludedIndex, 1);
      this.setState({ excludedSelectionIds });
      return;
    }

    const selectedItemIndex = selectedItems.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...selectedItems];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      selectedItems: selectedItemsUpdated
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: nextSelectedItems,
      isSelectAllChecked: false,
      excludedSelectionIds: []
    });
  };

  onSelectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: true,
      excludedSelectionIds: []
    });
  };

  resolveSelectedGovernorsForBulkAction = (callback: () => void): void => {
    const { isSelectAllChecked, excludedSelectionIds, filters } = this.state;
    if (!isSelectAllChecked) {
      callback();
      return;
    }
    this.setState({ isLoading: true });
    getAllGovernors(this.props.user, getServerFieldSectionWhere(filters))
      .then(items => {
        const excludedIds = new Set(excludedSelectionIds);
        this.setState({ selectedItems: items.filter(item => !excludedIds.has(item.id)), isLoading: false }, callback);
      })
      .catch(error => {
        this.setState({ isLoading: false });
        console.error('Unable to resolve all selected governors', error);
      });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      excludedSelectionIds: []
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = FILTER_COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected && options[i].value !== '') {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onSearchFilterChange = (event, filterField: 'nameSearch'): void => {
    const value = event.target.value;
    this.setState(state => ({
      filters: {
        ...state.filters,
        [filterField]: value
      }
    }));
  };

  onTagFilterToggle = (value: string): void => {
    const current = Array.isArray(this.state.filters.tag)
      ? this.state.filters.tag
      : this.state.filters.tag
      ? [this.state.filters.tag]
      : [];
    this.setState({
      filters: {
        ...this.state.filters,
        tag: current.indexOf(value) === -1 ? [...current, value] : current.filter(item => item !== value)
      }
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      excludedSelectionIds: [],
      isShowFilter: false
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onClearFilterClick = (): void => {
    this.setState({
      filters: {},
      selectedItems: [],
      isSelectAllChecked: false,
      excludedSelectionIds: [],
      isShowFilter: false
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: ''
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter
    });
  };

  onSendMessageClick = () => {
    this.resolveSelectedGovernorsForBulkAction(() => {
      const activeSchoolId = this.props.user.activeSchoolId;
      const governorUsers = this.state.selectedItems
        .map(schoolUser => ({
          ...schoolUser,
          permissions: propz.get(schoolUser, ['permissions'], []).filter(permission => {
            const schoolId = propz.get(permission, ['schoolId']);
            return (
              propz.get(permission, ['preset']) === 'GOVERNOR' &&
              propz.get(permission, ['status']) === 'ACTIVE' &&
              (!schoolId || !activeSchoolId || schoolId.toString() === activeSchoolId.toString())
            );
          })
        }))
        .filter(schoolUser => schoolUser.permissions.length > 0);

      this.props.history.push({
        pathname: '/generalMessages/create',
        state: {
          fromAllUsersList: true,
          users: governorUsers,
          returnTo: {
            pathname: this.state.basePath,
            search: this.props.location.search
          }
        }
      });
    });
  };

  onUserTagChange = (event): void => {
    const value = event.target.value;

    this.setState({
      selectedUserTagId: value
    });
  };

  onUserTagSaveClick = (selectedTagIds: string[] = []): void => {
    const tagIds = selectedTagIds.length ? selectedTagIds : [this.state.selectedUserTagId].filter(Boolean);
    const user = this.props.user;

    this.setState({
      isLoading: true
    });

    if (tagIds.length === 0) {
      this.setState({
        isUserTagModalOpen: false,
        selectedUserTagId: ''
      });
      console.error('Can not assign user tag id');
    } else {
      const selectedItems = this.state.selectedItems;
      updateUserTagsInBulk(
        user,
        selectedItems.map(item => item.id),
        tagIds,
        'ADD'
      )
        .then(() => {
          this.setState({
            isUserTagModalOpen: false,
            selectedUserTagId: '',
            selectedItems: [],
            isSelectAllChecked: false,
            excludedSelectionIds: []
          });
          this.setItems();
        })
        .catch(error => {
          console.error('Can not assign governor tags', error);
          this.setState({ isLoading: false });
        });
    }
  };

  renderUserTagAssignModal(): React.ReactNode {
    const { tags, selectedUserTagId, isUserTagModalOpen, selectedItems } = this.state;
    const excludedUserTagIds = this.getUserTags().map(tag => tag.id);

    return (
      <UserTagAssignModal
        modalTitle={'Assign User Tag'}
        userTags={tags}
        excludedUserTagIds={excludedUserTagIds}
        selectedStudents={selectedItems}
        selectedUserTagId={selectedUserTagId}
        onUserTagChange={this.onUserTagChange}
        onCloseClick={this.closeUserTagAssignModal}
        isOpen={isUserTagModalOpen}
        onSaveClick={this.onUserTagSaveClick}
      />
    );
  }

  openUserTagAssignModal = (): void => {
    this.resolveSelectedGovernorsForBulkAction(() => {
      this.setState({ isUserTagModalOpen: true });
    });
  };

  closeUserTagAssignModal = () => {
    this.setState({
      isUserTagModalOpen: false
    });
  };

  getUserTags(): Tag[] {
    const { selectedItems, items } = this.state;

    const tags = Lazy(selectedItems)
      .map(selectedItem => {
        const selectedItemId = selectedItem.id;
        const user = items.find(userState => userState.id === selectedItemId);

        if (typeof user !== 'undefined') {
          return user.permissions[0].tags;
        } else {
          return [];
        }
      })
      .filter(tagList => tagList.length > 0)
      .flatten()
      .uniq('id')
      .toArray();

    return tags;
  }

  onUserTagDelete = (selectedTagIds?: string[]): void => {
    const userTagIds =
      selectedTagIds && selectedTagIds.length ? selectedTagIds : [this.state.selectedUserTagId].filter(Boolean);
    const user = this.props.user;

    this.setState({
      isLoading: true
    });

    if (userTagIds.length === 0) {
      this.setState({
        isUserTagDeleteModalOpen: false,
        selectedUserTagId: ''
      });
      console.error('Can not assign user tag id');
    } else {
      const selectedItems = this.state.selectedItems;

      updateUserTagsInBulk(
        user,
        selectedItems.map(item => item.id),
        userTagIds,
        'REMOVE'
      )
        .then(() => {
          this.setState({
            isUserTagDeleteModalOpen: false,
            selectedUserTagId: '',
            selectedItems: [],
            isSelectAllChecked: false,
            excludedSelectionIds: []
          });
          this.setItems();
        })
        .catch(error => {
          console.error('Can not remove governor tags', error);
          this.setState({ isLoading: false });
        });
    }
  };

  renderUserTagDeleteModal(): React.ReactNode {
    const { selectedUserTagId, isUserTagDeleteModalOpen } = this.state;

    return (
      <UserTagDeleteModal
        modalTitle={'Delete User Tag'}
        userTags={this.getUserTags()}
        selectedUserTagId={selectedUserTagId}
        onUserTagChange={this.onUserTagChange}
        onCloseClick={this.closeUserTagDeleteModal}
        isOpen={isUserTagDeleteModalOpen}
        onDeleteClick={this.onUserTagDelete}
      />
    );
  }

  openUserTagDeleteModal = () => {
    this.resolveSelectedGovernorsForBulkAction(() => {
      this.setState({ isUserTagDeleteModalOpen: true });
    });
  };

  closeUserTagDeleteModal = () => {
    this.setState({
      isUserTagDeleteModalOpen: false
    });
  };

  getUserFullName(user: SchoolUser): string {
    return `${propz.get(user, ['firstName'], '')} ${propz.get(user, ['lastName'], '')}`.trim() || 'Unnamed user';
  }

  getUserInitials(user: SchoolUser): string {
    return `${propz.get(user, ['firstName'], '?').charAt(0)}${propz.get(user, ['lastName'], '').charAt(0)}`;
  }

  getActivePermissions(user: SchoolUser): any[] {
    return propz.get(user, ['permissions'], []).filter(permission => propz.get(permission, ['status']) === 'ACTIVE');
  }

  getUserRoleNames(user: SchoolUser): string[] {
    return Lazy(this.getActivePermissions(user))
      .map(permission => propz.get(permission, ['preset']))
      .filter(role => Boolean(role))
      .uniq()
      .toArray() as string[];
  }

  getSafeUserTags(user: SchoolUser): Tag[] {
    return Lazy(this.getActivePermissions(user))
      .map(permission => propz.get(permission, ['tags'], []))
      .flatten()
      .filter(tag => Boolean(tag))
      .uniq('id')
      .toArray() as Tag[];
  }

  renderUserAvatar(user: SchoolUser): React.ReactNode {
    const avatar = propz.get(user, ['avatar'], '');
    return (
      <span className="people-avatar people-avatar--lg">
        {this.getUserInitials(user)}
        {avatar ? <img src={avatar} alt="" onError={event => (event.currentTarget.style.display = 'none')} /> : null}
      </span>
    );
  }

  renderUserTags(user: SchoolUser): React.ReactNode {
    const tags = this.getSafeUserTags(user);

    if (tags.length === 0) return <span className="users-accessEmpty">No tags assigned.</span>;

    return (
      <span className="people-tags">
        {tags.map(tag => (
          <span key={tag.id || tag.tagName} style={{ '--tag-color': getUserTagColor(tag) } as React.CSSProperties}>
            <i />
            {tag.tagName}
          </span>
        ))}
      </span>
    );
  }

  renderUserDetails(user: SchoolUser): React.ReactNode {
    const rows: Array<[string, React.ReactNode]> = [
      ['Name', this.getUserFullName(user)],
      ['Email', getEmailOrMisEmail(user) || '-'],
      ['Phone', getPhoneOrMisPhone(user) || '-'],
      ['Birthday', getBirthday(user) || '-'],
      ['Status', getUserStatus(user) || '-'],
      ['Tags', this.renderUserTags(user)]
    ];

    return (
      <div className="users-detailList">
        {rows.map(([label, value]) => (
          <div key={label} className="users-detailRow">
            <span>{label}</span>
            <strong>{value}</strong>
          </div>
        ))}
      </div>
    );
  }

  renderUserRoles(user: SchoolUser): React.ReactNode {
    const permissions = this.getActivePermissions(user);

    if (permissions.length === 0) {
      return <div className="users-accessEmpty">No active roles.</div>;
    }

    return (
      <div className="users-detailList">
        {permissions.map((permission, index) => {
          const role = propz.get(permission, ['preset'], 'Role');
          const schoolName = propz.get(
            permission,
            ['school', 'name'],
            this.props.user.activeSchoolName || 'Current school'
          );
          return (
            <div key={propz.get(permission, ['id'], `${role}-${index}`)} className="users-detailRow">
              <span>{ROLE_SERVER_TO_CLIENT_MAPPING[role] || role}</span>
              <strong>{schoolName}</strong>
            </div>
          );
        })}
      </div>
    );
  }

  renderUserPreview(): React.ReactNode {
    const { previewUser, currentTabIndex } = this.state;

    if (!previewUser) return null;

    const roles = this.getUserRoleNames(previewUser);
    const roleLabel = roles.map(role => ROLE_SERVER_TO_CLIENT_MAPPING[role] || role).join(', ') || 'No active role';
    const tabs = ['Summary', 'Roles'];

    return (
      <>
        <div className="people-drawerScrim" onClick={this.closeUserPreview} />
        <aside className="people-drawer" role="dialog" aria-modal="true" aria-label="Trustee or governor details">
          <div className="people-drawer__head">
            {this.renderUserAvatar(previewUser)}
            <div className="people-drawer__identity">
              <h2>{this.getUserFullName(previewUser)}</h2>
              <div>
                <span>{roleLabel}</span>
                <i />
                <span>{getEmailOrMisEmail(previewUser) || 'No email'}</span>
              </div>
            </div>
            <button type="button" className="people-drawer__close" onClick={this.closeUserPreview} aria-label="Close">
              ×
            </button>
          </div>

          <div className="people-drawer__tabs">
            {tabs.map((tab, index) => (
              <button
                key={tab}
                type="button"
                className={currentTabIndex === index ? 'active' : ''}
                onClick={() => this.setState({ currentTabIndex: index })}
              >
                {tab}
                {index === 1 ? ` (${roles.length})` : ''}
              </button>
            ))}
          </div>

          <div className="people-drawer__body">
            {currentTabIndex === 0 ? this.renderUserDetails(previewUser) : this.renderUserRoles(previewUser)}
          </div>

          <div className="people-drawer__foot users-drawerFoot">
            <button
              type="button"
              className="people-btn people-btn--secondary"
              onClick={() => this.usePreviewUserForAction(this.onSendMessageClick)}
            >
              <FontAwesomeIcon icon={faEnvelope} /> Message
            </button>
            <button
              type="button"
              className="people-btn people-btn--secondary"
              onClick={() => this.usePreviewUserForAction(this.openUserTagAssignModal)}
            >
              <FontAwesomeIcon icon={faTags} /> Assign tag
            </button>
            <button
              type="button"
              className="people-btn people-btn--secondary"
              disabled={this.getSafeUserTags(previewUser).length === 0}
              onClick={() => this.usePreviewUserForAction(this.openUserTagDeleteModal)}
            >
              <FontAwesomeIcon icon={faTrashAlt} /> Remove tag
            </button>
          </div>
        </aside>
      </>
    );
  }

  render() {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      isLoading,
      isSelectAllChecked,
      excludedSelectionIds,
      currentPage,
      total,
      tags,
      hiddenColumns
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const classes = 'mt-3';

    const filterOptions = {
      tag: getSelectOptionForTag(tags)
    };

    const selectedIds = new Set(selectedItems.map(item => item.id));
    const excludedIds = new Set(excludedSelectionIds);
    const allPageSelected = isSelectAllChecked
      ? items.length > 0 && items.every(item => !excludedIds.has(item.id))
      : items.length > 0 && items.every(item => selectedIds.has(item.id));
    const selectedCount = isSelectAllChecked ? Math.max(0, total - excludedSelectionIds.length) : selectedItems.length;
    const visibleColumns = COLUMNS.filter(column => !hiddenColumns.includes(column.field));
    const getFilterValue = (field: string): string => {
      const value = filters[field];
      return Array.isArray(value) ? value[0] || '' : value && typeof value === 'object' ? '' : String(value || '');
    };
    const getCellValue = (item: SchoolUser, column: ColumnDefinition): React.ReactNode => {
      if (column.field === 'firstName') {
        const initials = `${propz.get(item, ['firstName'], '?').charAt(0)}${propz
          .get(item, ['lastName'], '')
          .charAt(0)}`;
        return (
          <div className="people-person">
            <span className="people-avatar">{initials}</span>
            <span className="people-person__name">{propz.get(item, ['firstName'], '-')}</span>
          </div>
        );
      }
      if (column.field === 'tag') {
        const itemTags = Lazy(propz.get(item, ['permissions'], []))
          .map(permission => propz.get(permission, ['tags'], []))
          .flatten()
          .filter(tag => Boolean(tag))
          .uniq('id')
          .toArray() as Tag[];

        if (itemTags.length === 0) {
          return <span className="people-flag people-flag--off">-</span>;
        }

        return (
          <span className="people-tags">
            {itemTags.slice(0, 2).map(tag => {
              const color = getUserTagColor(tag);
              return (
                <span key={tag.id || tag.tagName} style={{ '--tag-color': color } as React.CSSProperties}>
                  <i />
                  {tag.tagName}
                </span>
              );
            })}
            {itemTags.length > 2 ? <span className="people-tagsMore">+{itemTags.length - 2} more</span> : null}
          </span>
        );
      }
      const accessor = (column as any).accessor;
      if (typeof accessor === 'function') {
        return accessor(item);
      }
      return Array.isArray(accessor) ? propz.get(item, accessor, '-') || '-' : '-';
    };
    const toggleAllOnPage = (): void => {
      if (allPageSelected) {
        const pageIds = new Set(items.map(item => item.id));
        if (isSelectAllChecked) {
          this.setState({
            excludedSelectionIds: Array.from(new Set([...excludedSelectionIds, ...Array.from(pageIds)]))
          });
          return;
        }
        this.setState({
          selectedItems: selectedItems.filter(item => !pageIds.has(item.id)),
          isSelectAllChecked: false
        });
      } else {
        if (isSelectAllChecked) {
          this.setState({
            excludedSelectionIds: excludedSelectionIds.filter(id => !items.some(item => item.id === id))
          });
          return;
        }
        const next = [...selectedItems];
        items.forEach(item => {
          if (!selectedIds.has(item.id)) {
            next.push(item);
          }
        });
        this.setState({ selectedItems: next });
      }
    };

    return (
      <div className={`${classes} schoolPeoplePage`}>
        {/*Place for render modal windows*/}
        {this.renderUserTagAssignModal()}
        {this.renderUserTagDeleteModal()}
        {this.renderUserPreview()}
        <PeopleListPageHeader title="Trustees & Governors" total={total} />
        <div className="people-screen governors-modernScreen schoolPeopleListCard">
          <div className="people-toolbar">
            <div className="people-toolbar__heading">
              <div className="people-search people-search--name">
                <label className="people-search__field">
                  <span>Name</span>
                  <input
                    value={getFilterValue('nameSearch')}
                    placeholder="Search by first or last name"
                    onChange={event => this.onSearchFilterChange(event, 'nameSearch')}
                    onKeyDown={event => event.key === 'Enter' && this.onApplyFilterClick()}
                  />
                </label>
              </div>
              <button
                type="button"
                className={`people-btn people-btn--secondary people-btn--iconLeft people-filterBtn ${
                  isShowFilter ? 'people-btn--on' : ''
                }`}
                onClick={this.onTableFilterClick}
              >
                <span className="people-icon people-icon--filter" />
                Filters
                {countActivePeopleFilters(filters) > 0 && (
                  <span className="people-btn__badge">{countActivePeopleFilters(filters)}</span>
                )}
              </button>
              <PeopleColumnsMenu
                columns={COLUMNS.map(column => ({ key: column.field, label: column.text }))}
                hidden={hiddenColumns}
                onChange={next => {
                  saveHiddenColumns(this.props.user, 'people.governors', next);
                  this.setState({ hiddenColumns: next });
                }}
              />
            </div>
          </div>
          {isShowFilter && (
            <form
              className="people-filter governors-filter"
              onSubmit={event => {
                event.preventDefault();
                this.onApplyFilterClick();
              }}
            >
              <div className="people-filter__header">
                <strong>Filters</strong>
                <button
                  type="button"
                  onClick={() => {
                    this.setState({ isShowFilter: false });
                    this.setItems();
                  }}
                  aria-label="Close filters"
                >
                  ×
                </button>
              </div>
              <div className="people-filter__body">
                <label className="people-filter__field">
                  <span>Email</span>
                  <input
                    className="governors-filter__control"
                    value={getFilterValue('email')}
                    placeholder="Search email"
                    onChange={event => this.onTableFilterChange(event, 'email')}
                  />
                </label>
                <label className="people-filter__field">
                  <span>Phone</span>
                  <input
                    className="governors-filter__control"
                    value={getFilterValue('phone')}
                    placeholder="Search by phone"
                    onChange={event => this.onTableFilterChange(event, 'phone')}
                  />
                </label>
                <PeopleFilterChipSelect
                  label="Tags"
                  selected={(Array.isArray(filters.tag) ? filters.tag : filters.tag ? [filters.tag] : []).map(String)}
                  collapsedLimit={6}
                  options={filterOptions.tag.map(option => ({
                    value: String(option.value),
                    label: String(option.text || option.value),
                    color: option.color
                  }))}
                  onToggle={this.onTagFilterToggle}
                />
              </div>
              <div className="people-filter__actions">
                <button type="button" className="people-btn people-btn--ghost" onClick={this.onClearFilterClick}>
                  Clear all
                </button>
                <div>
                  <button
                    type="button"
                    className="people-btn people-btn--secondary"
                    onClick={() => {
                      this.setState({ isShowFilter: false });
                      this.setItems();
                    }}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="people-btn people-btn--primary">
                    Apply
                  </button>
                </div>
              </div>
            </form>
          )}
          <PeopleFilterChips
            filters={filters}
            columns={FILTER_COLUMNS}
            valueLabels={{
              tag: filterOptions.tag.reduce((result, option) => {
                result[option.value] = option.text || option.value;
                return result;
              }, {})
            }}
            onRemove={field => this.setState({ filters: { ...filters, [field]: '' } }, this.onApplyFilterClick)}
            onClear={this.onClearFilterClick}
          />
          {selectedCount > 0 && (
            <div className="people-selection">
              <span className="people-selection__summary">{selectedCount} selected</span>
              <div className="people-selection__actions">
                <button type="button" className="people-btn people-btn--secondary" onClick={this.onSendMessageClick}>
                  <span aria-hidden="true">+</span> Create message
                </button>
                <button
                  type="button"
                  className="people-btn people-btn--secondary"
                  onClick={this.openUserTagAssignModal}
                >
                  Assign tag
                </button>
                <button
                  type="button"
                  className="people-btn people-btn--secondary"
                  onClick={this.openUserTagDeleteModal}
                >
                  Remove tag
                </button>
                <button type="button" className="people-btn people-btn--secondary" onClick={this.onSelectAllClick}>
                  Select all filtered
                </button>
              </div>
              <div className="people-toolbar__spacer" />
              <button type="button" className="people-selection__clear" onClick={this.onUnselectAllClick}>
                Clear selection
              </button>
            </div>
          )}
          <div className="people-tableCard">
            <div className="people-tableWrap">
              <table className="people-table">
                <thead>
                  <tr>
                    <th className="people-table__check">
                      <SelectAllCheckbox
                        compact
                        isChecked={allPageSelected}
                        totalCount={total}
                        currentPage={currentPage}
                        pageItemsCount={items.length}
                        selectedItems={selectedItems}
                        selectedItemsCount={selectedCount}
                        onSelectAllOnPageClick={this.onSelectAllOnPageClick}
                        onSelectAllClick={this.onSelectAllClick}
                        onUnselectAllClick={this.onUnselectAllClick}
                      />
                    </th>
                    {visibleColumns.map(column => {
                      const isSorted = sortColumnsName === column.field;
                      return (
                        <th
                          key={column.field}
                          onClick={column.isSort ? () => this.onTableSortClick(column.field) : undefined}
                          className={column.isSort ? 'people-table__sortable' : ''}
                        >
                          <span>{column.text}</span>
                          {column.isSort && (
                            <i className={`people-sort ${isSorted ? `people-sort--${sortDirection}` : ''}`} />
                          )}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {items.length === 0 ? (
                    <tr>
                      <td className="people-empty" colSpan={visibleColumns.length + 1}>
                        <ListEmptyState
                          icon={faUserShield}
                          title={isDataFiltered ? 'No trustees or governors match your filters' : 'No trustees or governors yet'}
                          description={
                            isDataFiltered
                              ? 'Try changing or clearing the search and filters to see more people.'
                              : 'Trustees, governors and their contact details will appear here.'
                          }
                        />
                      </td>
                    </tr>
                  ) : (
                    items.map((item, index) => (
                      <tr
                        key={item.id}
                        data-selected={isSelectAllChecked ? !excludedIds.has(item.id) : selectedIds.has(item.id)}
                        data-preview={this.state.previewUser && this.state.previewUser.id === item.id}
                        onClick={() => this.onUserPreviewClick(item)}
                      >
                        <td className="people-table__check" onClick={event => event.stopPropagation()}>
                          <input
                            type="checkbox"
                            checked={isSelectAllChecked ? !excludedIds.has(item.id) : selectedIds.has(item.id)}
                            onChange={() => this.onItemClick(index)}
                          />
                        </td>
                        {visibleColumns.map(column => (
                          <td key={column.field}>{getCellValue(item, column)}</td>
                        ))}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {total > 0 ? (
            <Pagination2
              modern
              currentPage={currentPage}
              total={total}
              setCurrentPageParams={this.setCurrentPageParams}
            />
          ) : null}
        </div>
      </div>
    );
  }
}
